namespace Gamification.Gamification {
    export enum SmtpSecureSocketOptionsEnum {
        None = 0,
        Auto = 1,
        SslOnConnect = 2,
        StartTls = 3,
        StartTlsWhenAvailable = 4
    }
    Serenity.Decorators.registerEnumType(SmtpSecureSocketOptionsEnum, 'Gamification.Gamification.SmtpSecureSocketOptionsEnum', 'Gamification.SmtpSecureSocketOptionsEnum');
}
